import React from 'react'
import { connect } from 'react-redux'

class JobDescriptionBox extends React.Component{
  constructor(props){
    super(props)
    this.scrollHandler = this.scrollHandler.bind(this)
  }

  componentWillMount(){
    window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('resize', this.scrollHandler)
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('resize', this.scrollHandler)
  }

  /**
    Makes sure the job descriptions scrolls down all the way down to the bottom of the timeline
    and all the way up to the top of the timeline
  */
  scrollHandler(){
    let margin = 50
    
    let timelineContainer = document.getElementById('timeline-container')
    let listEl = document.getElementById('selected-job')
    let timeline = document.getElementById('timeline')

    if (!listEl || !timelineContainer || !timeline)
      return

    let listElRect = listEl.getBoundingClientRect()
    let timeLineRect = timeline.getBoundingClientRect()
    let timelineContainerRect = timelineContainer.getBoundingClientRect()

    if (!listEl.classList.contains('sticky') && timelineContainerRect.top<=window.innerHeight*.2 && timeLineRect.bottom>4*margin + listEl.clientHeight){
      listEl.classList.add('sticky')
      listEl.style.marginTop = ""
    }

    else if (listEl.classList.contains('sticky') && timelineContainerRect.top>window.innerHeight*.2){
      listEl.classList.remove('sticky')
    }

    else if (listEl.classList.contains('sticky')&& listElRect.bottom+margin>timelineContainerRect.bottom){
      listEl.classList.remove('sticky')
      listElRect = listEl.getBoundingClientRect()
      timeLineRect = document.getElementById('timeline').getBoundingClientRect()
      listEl.style.marginTop = `${timeLineRect.bottom - listElRect.bottom - margin}px`
    }
    return
  }

  render(){
    let desc, content, title
    const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
    const currentItem = this.props.currentItem

    if (currentItem.length==0)
      content =  <h5>Click on an item in the timeline for details </h5>

    else{
      let startDate = `${months[currentItem.startDate.getMonth()]} ${currentItem.startDate.getFullYear()}`
      let endDate = `${months[currentItem.endDate.getMonth()]} ${currentItem.endDate.getFullYear()}`
      let courses
      desc = currentItem.desc.map((d, i)=>{
        if (typeof(d)=="object" && d.hasOwnProperty('courses')){
          courses = d.courses.map((c, j)=>{
            return <li className="browser-default" key={`c${j}`}>{c}</li>
          })
          return (
            <div key={`coursesDiv${i}`}>
              <li>Courses:</li>
                <ul className="browser-default">
                  {courses}
                </ul>
            </div>
          )
        }
        return <li className="browser-default" key={i} style={d.startsWith("|||") ? {fontWeight: 600, listStyle: 'none', fontSize: 'larger', translate: '-1.5rem'}: {}}>
          {d.replace("|||", "")}
        </li>
      })
      content = (
        <div>
          <h5> {currentItem.longTitle||"NO TITLE"} ({startDate} &ndash; {endDate}) </h5>
          <ul className="browser-default">{desc}</ul>
        </div>
      )
       
    }

    return(
        <div id="selected-job" className="center-allign">
         {content}
        </div>
    )
  }
}

function mapStateToProps(state){
  return state.ResumeReducer
}

export default connect(mapStateToProps, null)(JobDescriptionBox)


// WEBPACK FOOTER //
// ./app/components/JobDescriptionBox.js